import apiService from '@/services/ApiService'

export default {

  async fetchCompanyByExternalId (countryCode, externalId, externalValue) {
    let params = {
      countryCode: countryCode,
      service: externalId,
      id: externalValue,
      version: '2'
    }
    try {
      let response = await apiService.getServiceForCompaniesV3().get(`transactors`, { params })
      return response.status === 200 ? response.data.Id : ''
    } catch (err) {
      console.log(err)
      return ''
    }
  },

  async fetchCompanyById (companyId) {
    let params = {
      version: '3'
    }
    try {
      let response = await apiService.getServiceForCompaniesV3().get(`companies/${companyId}`, { params })
      return response.status === 200 ? response.data : undefined
    } catch (err) {
      console.log(err)
      return undefined
    }
  },

  async fetchCompaniesByIds (companyIds) {
    let distinctCompanyIds = [...new Set(companyIds)]

    let batches = []
    let batchSize = 50
    let idsIndex = 0
    while (idsIndex <= distinctCompanyIds.length) {
      batches.push(distinctCompanyIds.slice(idsIndex, idsIndex + batchSize))
      idsIndex += batchSize
    }
    try {
      let result = []
      for (let iBatch = 0; iBatch < batches.length; iBatch++) {
        const batch = batches[iBatch]
        let params = {
          version: '3',
          ids: batch.join(',')
        }
        let response = await apiService.getServiceForCompaniesV3().get(`companies`, { params })
        if (response.status === 200) {
          result.push(...response.data)
        } else {
          return undefined
        }
      }
      return result
    } catch (err) {
      console.log(err)
      return undefined
    }
  }
}
